function getSideMenuTeamSwitcherMenuStyle() {
	return {
		height: '100vh',
		maxHeight: 'calc(100vh - 60px)',
		overflowY: 'auto',
	};
}

export const muiMenuListOverrides = {
	styleOverrides: {
		root: () => ({
			variants: [
				{
					props: {
						'ts-variant': 'sideMenuTeamSwitcherMenu',
					},
					style: getSideMenuTeamSwitcherMenuStyle(),
				},
			],
		}),
	},
};
